/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccommodationListings_Listing } from '../models/AccommodationListings_Listing';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AccommodationListingsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves the collection of listings for given accommodation.
     * Retrieves the collection of AccommodationListings resources.
     * @param id AccommodationListings identifier
     * @param country
     * @returns AccommodationListings_Listing AccommodationListings collection
     * @throws ApiError
     */
    public accommodationListingsObtainer(
        id: string,
        country?: string,
    ): CancelablePromise<Array<AccommodationListings_Listing>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accommodations/{id}/listings',
            path: {
                id: id,
            },
            query: {
                country: country,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
